<mat-sidenav-container class="example-container" style="min-height: 100vh; height: auto;">
  <mat-sidenav #sidenav mode="over" [opened]="false" class="premium-sidenav">
    
    <!-- Premium Header -->
    <div class="sidenav-header" style="position: sticky; top: 0; z-index: 100;">
      <div class="close-btn" (click)="sidenav.close()">
        <i class="fa fa-times"></i>
      </div>
      <div class="user-profile">
        <div class="avatar">
           <i class="fa fa-user" style="margin-left: 2px;"></i>
        </div>
        <div class="user-info">
          <h3 class="user-name text-truncate">Welcome, {{userData?.fullName ? userData?.fullName : "Guest"}}</h3>
          <p class="user-location text-truncate"><i class="fa fa-map-marker text-accent"></i> {{city || 'Select Location'}}</p>
        </div>
      </div>
    </div>

    <!-- Navigation Menu -->
    <div class="sidenav-menu custom-scrollbar">
      
      <div class="menu-group-title">Main Menu</div>
      <a href="/" class="menu-item" routerLink="/" (click)="sidenav.close()">
        <i class="fa fa-home menu-icon"></i> Home
      </a>
      
      <div class="menu-divider"></div>
      <div class="menu-group-title">Categories</div>
      <ng-container *ngFor="let data of allCategoryData">
        <a *ngIf="isExternalUrl(getCategoryUrl(data))" class="menu-item" [href]="getCategoryUrl(data)" target="_blank" rel="noopener noreferrer" (click)="sidenav.close()">
          <i class="fa fa-cube menu-icon"></i> {{data?.name}}
        </a>
        <a *ngIf="!isExternalUrl(getCategoryUrl(data))" class="menu-item" [href]="getCategoryUrl(data)" [routerLink]="getCategoryUrl(data)" (click)="sidenav.close()">
          <i class="fa fa-cube menu-icon"></i> {{data?.name}}
        </a>
      </ng-container>

      <div class="menu-divider"></div>
      <div class="menu-group-title">Quick Links</div>
      <a href="/leads" class="menu-item" routerLink="/leads" (click)="sidenav.close()">
        <i class="fa fa-bullhorn menu-icon"></i> Latest Buy Lead
      </a>
      <a href="/about-us" class="menu-item" routerLink="/about-us" (click)="sidenav.close()">
        <i class="fa fa-info-circle menu-icon"></i> About Us
      </a>
      <a href="/contact-us" class="menu-item" routerLink="/contact-us" (click)="sidenav.close()">
        <i class="fa fa-envelope menu-icon"></i> Contact
      </a>

      <div class="menu-divider"></div>
      <div class="menu-group-title">Support & Legal</div>
      <a href="/feedback" class="menu-item" routerLink="/feedback" (click)="sidenav.close()">
        <i class="fa fa-star menu-icon"></i> Feedback
      </a>
      <a href="/complain" class="menu-item" routerLink="/complain" (click)="sidenav.close()">
        <i class="fa fa-exclamation-triangle menu-icon"></i> Complaint
      </a>
      <a href="/terms-of-use" class="menu-item" routerLink="/terms-of-use" (click)="sidenav.close()">
        <i class="fa fa-file-text menu-icon"></i> Terms of Use
      </a>
      <a href="/privacy-policy" routerLink="/privacy-policy" (click)="sidenav.close()" class="menu-item">
        <i class="fa fa-shield menu-icon"></i> Privacy Policy
      </a>
      
    </div>

    <!-- Sidenav Footer -->
    <div class="sidenav-footer">
      <div class="app-brand">
        <strong>Btechmart</strong> <span class="badge badge-danger beta-badge">BETA v1.0</span>
      </div>
      <p class="app-desc">Your ultimate B2B marketplace. Connecting businesses seamlessly across categories.</p>
      <div class="copyright text-muted">
        &copy; 2026 Btechmart.<br>All rights reserved.
      </div>
    </div>

  </mat-sidenav>
  <mat-sidenav-content style="min-height: 100vh; height: auto; overflow: visible !important;">
    <app-header (menu)="sidenav.toggle()" style="position: sticky; top: 0; z-index: 1050; display: block;"></app-header>

    <!-- Semantic Main Landmark for accessibility and screen readers -->
    <main id="main-content" role="main">
      <router-outlet></router-outlet>
    </main>

    <app-footer></app-footer>
  </mat-sidenav-content>

</mat-sidenav-container>
